import { Box, Typography, Stack } from "@mui/material";
import { WaydImpactBarProps } from "./types";
import { grey, red } from "@mui/material/colors";

export default function WaydImpactBar({
  title,
  value,
  percentile,
}: WaydImpactBarProps) {
  return (
    <Stack sx={{ width: 170 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="body2">{title}</Typography>
        <Typography variant="body2">
          {value > 0 && "+"}
          {value.toFixed(2)}
        </Typography>
      </Stack>
      <Box
        sx={{
          width: "100%",
          height: 16,
          bgcolor: grey[200],
          position: "relative",
          borderRadius: 1,
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            width: `${percentile}%`,
            height: "100%",
            bgcolor: red[800],
          }}
        />
      </Box>
    </Stack>
  );
}
